import { useGetSizesProps } from "./types";
import { Button } from "primereact/button";
import { UnitSizeRead, UnitCategoryRead } from "@types";
import Defaults from "@/assets/Rectangle 391.png";

interface ExtraProps {
  categories: UnitCategoryRead[];
}

export const useGetUnitSizes = ({
  onEdit,
  onDelete,
  categories,
}: useGetSizesProps & ExtraProps) => {
  const handleDeleteClick = (rowData: UnitSizeRead) => {
    if (rowData && rowData.id) {
      onDelete(rowData.id);
    }
  };

  const columns = [
    {
      field: "image",
      header: "",
      body: (rowData: UnitSizeRead) => (
        <div className="max-w-6rem max-h-6rem overflow-hidden">
          <img
            src={rowData.imageUrl || Defaults}
            alt="promotion"
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    { field: "description", header: "Description" },
    { field: "width", header: "Width" },
    { field: "length", header: "Length" },
    {
      field: "category",
      header: "Category",
      body: (rowData: UnitSizeRead) => {
        const category = categories.find(
          (c) => c.id === rowData.unitCategoryId,
        );
        return <span>{category ? category.label : "No category"}</span>;
      },
    },

    {
      field: "actions",
      header: "",
      body: (rowData: UnitSizeRead) => (
        <div className="flex gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            onClick={() => onEdit(rowData)}
          />
          <Button
            icon="pi pi-trash"
            rounded
            outlined
            severity="danger"
            className="p-button-text p-button-sm"
            onClick={() => handleDeleteClick(rowData)}
          />
        </div>
      ),
    },
  ];

  return { columns };
};
